const prefix = '@@TOAST';

export const SHOW_TOAST = `${prefix}__SHOW_TOAST`;
